import "../styles/foundingTeam.css";
import UviweImage from "../assets/Uviwe.jpeg"; // Import the images
import AsipheImage from "../assets/Asiphe.jpeg";
import SbuImage from "../assets/Sbu.jpeg";
import ThandoImage from "../assets/Thando.jpeg";

const teamMembers = [
  { name: "Uviwe Makiva", education: "BCom Accounting, Cloud & Cybersecurty, and Fullstack Software Development", image: UviweImage },
  { name: "Asiphe Somabhele (Mrs. Ngalavu)", education: "Bachelor of Commerce in Accounting Science and Post Graduate Diploma in Accounting", image: AsipheImage },
  { name: "Sibusiso Nkambule", education: "Bachelor of Commerce in Accounting Sciences, and Post Graduate Diploma in Accounting.", image: SbuImage },
  { name: "Nomthandazo Dube", education: "Bachelor of Science in Biological Sciences (Animal, Plant, and Environmental Sciences)", image: ThandoImage }
];

const FoundingTeam = () => {
  return (
    <section className="founding-team-container">
      <div className="founding-team">
      <h2 className="section-title">Meet the Founders</h2>
      <div className="team-grid">
        {teamMembers.map((member, index) => (
          <div className="team-card" key={index}>
              <img src={member.image} alt={member.name} className="team-image" /> {/* Use member.image directly */}
              <h3>{member.name}</h3>
            <p>{member.education}</p>
          </div>
        ))}
      </div>
      </div>
    </section>
  );
};

export default FoundingTeam;
